module.exports = __webpack_public_path__ + "img/sun_orange.ff4c1eb7.svg";